(function () {
  'use strict';

  var debounceTimer = null;

  function getNewHTML(callback) {
    fetch('/cart?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(callback)
      .catch(function () {});
  }

  function swapEl(selector, doc) {
    var newEl = doc.querySelector(selector);
    var curEl = document.querySelector(selector);
    if (newEl && curEl) curEl.innerHTML = newEl.innerHTML;
  }

  function fadeSwapEl(selector, doc) {
    var newEl = doc.querySelector(selector);
    var curEl = document.querySelector(selector);
    if (!newEl || !curEl) return;
    curEl.style.transition = 'opacity 0.15s ease';
    curEl.style.opacity = '0';
    requestAnimationFrame(function () {
      curEl.innerHTML = newEl.innerHTML;
      requestAnimationFrame(function () { curEl.style.opacity = '1'; });
    });
  }

  // Alleen upsell zone — voor MutationObserver (Dawn heeft de rest al bijgewerkt)
  function refreshUpsellZone() {
    getNewHTML(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      fadeSwapEl('#CartDrawer-Upsell-Zone', doc);
    });
  }

  // Alle zones — voor na upsell add (Dawn werkt zelf niets bij)
  function refreshAllZones() {
    getNewHTML(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      swapEl('#CartDrawer-CartItems', doc);
      swapEl('.cart-drawer__footer', doc);
      fadeSwapEl('#CartDrawer-Upsell-Zone', doc);
    });
  }

  // MutationObserver op CartDrawer-CartItems
  // Dawn werkt dit element bij na elke cart-wijziging (remove, quantity, add)
  // → wij detecteren de mutatie en refreshen direct onze zone
  function initObserver() {
    var cartItems = document.getElementById('CartDrawer-CartItems');
    if (!cartItems) return;

    new MutationObserver(function (mutations) {
      var hasChildChanges = mutations.some(function (m) { return m.type === 'childList'; });
      if (!hasChildChanges) return;

      // Kleine debounce (50ms) om meerdere snelle mutaties samen te nemen
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(refreshUpsellZone, 50);
    }).observe(cartItems, { childList: true, subtree: false });
  }

  // Upsell "Toevoegen" knop
  // Dawn update CartItems NIET automatisch na onze /cart/add.js call,
  // dus doen we hier een directe zone-refresh na de response
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sj-upsell-btn');
    if (!btn) return;

    var variantId = btn.dataset.variant;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function () {
        btn.textContent = 'Toegevoegd ✓';
        refreshAllZones();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Toevoegen';
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }

}());
